// Shared timeline for the opening, in ms from the moment the hen is ready.
// The overlay hen and the scene both read from the same clock.
export const INTRO = {
  henIn: 600, // hen assembles in the middle of the screen
  flyStart: 1100, // starts hopping over to the hill
  flyEnd: 2200, // lands; the scene's own hen takes over
  revealStart: 1700, // the whole page dissolves in, outward from the hen
  revealEnd: 3000,
  done: 3100, // overlay removed
};

export const prefersReducedMotion = () =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// 4x4 ordered dither, the classic pixel art gradient
const BAYER = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5].map(
  (v) => (v + 0.5) / 16
);
export const bayer = (x, y) => BAYER[(y & 3) * 4 + (x & 3)];

// How far the reveal has spread, as a share of the distance to the farthest corner.
// It overshoots past 1 so the dithered edge clears the corners too.
export const revealFront = (elapsed) =>
  Math.max(0, Math.min(1, (elapsed - INTRO.revealStart) / (INTRO.revealEnd - INTRO.revealStart))) * 1.25;
